import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SnackBarService } from 'src/app/services/snack-bar.service';

@Component({ selector: 'app-dialog-token-gerado', templateUrl: './dialog-token-gerado.component.html' })
export class DialogTokenGeradoComponent {
  public constructor(
    @Inject(MAT_DIALOG_DATA) public data: { token: string },
    private dialogRef: MatDialogRef<DialogTokenGeradoComponent>,
    private snack: SnackBarService
  ) { }

  public async copiar(): Promise<void> {
    const copiado = await this.copiarParaAreaTransferencia(this.data.token);

    if (copiado) {
      this.snack.exibirSucesso('Token copiado!');
      return;
    }

    this.snack.exibirErro('Não foi possível copiar o token.');
  }

  public fechar(): void {
    this.dialogRef.close();
  }

  private async copiarParaAreaTransferencia(valor: string): Promise<boolean> {
    if (!valor) {
      return false;
    }

    if (navigator.clipboard && window.isSecureContext) {
      try {
        await navigator.clipboard.writeText(valor);
        return true;
      } catch {
        return this.copiarComFallback(valor);
      }
    }

    return this.copiarComFallback(valor);
  }

  private copiarComFallback(valor: string): boolean {
    const textarea = document.createElement('textarea');

    try {
      textarea.value = valor;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.left = '-9999px';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);

      textarea.focus();
      textarea.select();
      textarea.setSelectionRange(0, textarea.value.length);

      return document.execCommand('copy');
    } catch {
      return false;
    } finally {
      textarea.remove();
    }
  }
}
